import { createAction } from '../../utils/reduxUtils';
import { TourStopOfflineStatus } from '../../common';

const addTourStopOfflineStatus = createAction('ADD_TOURSTOPOFFLINESTATUS')<TourStopOfflineStatus>;

const syncTourStopOfflineStatusAsync = {
  request: createAction('SYNC_TOURSTOPOFFLINESTATUS_REQUEST')<string>,
  success: createAction('SYNC_TOURSTOPOFFLINESTATUS_SUCCESS')<string>,
  failure: createAction('SYNC_TOURSTOPOFFLINESTATUS_FAILURE')<string>,
};

const actions = {
  addTourStopOfflineStatus,
  syncTourStopOfflineStatusAsync,
};

export default actions;
